import React from 'react';
import { Hero } from '../components/home/Hero';
import { LogoMarquee } from '../components/home/LogoMarquee';
import { Services } from '../components/home/Services';
import { Process } from '../components/home/Process';
import { FeaturedRoles } from '../components/home/FeaturedRoles';
import { Testimonials } from '../components/home/Testimonials';
import { InsightsPreview } from '../components/home/InsightsPreview';
import { CTASection } from '../components/home/CTASection';
export function Home() {
  return <>
      <Hero data-id="element-477" data-mp="24htoqcscqiex" />
      <LogoMarquee data-id="element-478" data-mp="24hk6xchgnhkb" />
      <Services data-id="element-479" data-mp="24j4uuj99s297" />
      <Process data-id="element-480" data-mp="29g4zcpqh0wy7" />
      <FeaturedRoles data-id="element-481" data-mp="29flqdyistiwb" />
      <Testimonials data-id="element-482" data-mp="29f2byrscxcn1" />
      <InsightsPreview data-id="element-483" data-mp="29etu0lhdnh4z" />
      <CTASection data-id="element-484" data-mp="29ihmriezzzin" />
    </>;
}